export default {
	axiosToken: null,
	ready: false,
	loading: true,
	availableLanguages: [],
	auth: localStorage.getItem('ESCREEN_AUTH') ? JSON.parse(localStorage.getItem('ESCREEN_AUTH')) : {},
	user: localStorage.getItem('ESCREEN_USER') ? JSON.parse(localStorage.getItem('ESCREEN_USER')) : {},
	guestId: localStorage.getItem('ESCREEN_GUEST') ? localStorage.getItem('ESCREEN_GUEST') : '',
	userTeam: {},
	userTeams: [],
	showSwitchTeam: false,
	theme: 'light',
	translations: [],
	activeNavigation: false,
	leaveConfirmation: {
		changed: false,
		show: false,
		path: null
	},
	showExpirationDialog: false,
	showPlanLimitDialog: false
}
